// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option-free {\n  background-color: #8246AF;\n  width: fit-content;\n  padding: 3px 12px;\n  border-radius: 20px;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 15px;\n  margin: 11px; }\n", ""]);
// Exports
module.exports = exports;
